<template>
    <c-dialog ref="dialog" title="投诉建议详情" mode="slide" width="800" enable-flex mask-close :button="false">
        <template #head>
            <div class="m-detail-tag flex-center-cross">
                <label v-if="detailData.customer_name">{{detailData.customer_name}}</label>
                <c-state dict="suggestionTypcDic" tag :value="detailData.suggestion_type"></c-state>
            </div>
        </template>

        <div class="m-detail-box">
            <c-title>反馈内容</c-title>
            <c-detail>
                <c-detail-item label="反馈用户">
                    {{detailData.create_user_realname}}
                </c-detail-item>
                <c-detail-item label="用户类型">
                    <c-state dict="userTypeDic" tag :value="detailData.suggestion_user_type"></c-state>
                </c-detail-item>
                <c-detail-item label="反馈内容">
                    {{detailData.feedback_content}}
                </c-detail-item>
                <c-detail-item label="反馈图片">
                    <c-file-list :value="detailData.feedback_images"></c-file-list>
                </c-detail-item>
                <c-detail-item label="反馈时间">
                    {{detailData.create_date}}
                </c-detail-item>
                <c-detail-item label="处理状态">
                    <c-state dict="suggestionStateDic" tag :value="detailData.status"></c-state>
                </c-detail-item>
                <custom-detail ref="customDetail" work-type="3" :data="detailData.custom_fields_value_json"></custom-detail>
            </c-detail>
            <c-title v-if="detailData.status == 2">平台回复</c-title>
            <c-detail v-if="detailData.status == 2">
                <c-detail-item label="处理人" v-if="detailData.status == 2 && detailData.handler_user_realname">
                    {{detailData.handler_user_realname}}
                </c-detail-item>
                <c-detail-item label="处理时间" v-if="detailData.status == 2 && detailData.handle_time">
                    {{detailData.handle_time}}
                </c-detail-item>
                <c-detail-item label="平台回复内容" v-if="detailData.status == 2">
                    {{detailData.reply_content}}
                </c-detail-item>

                <custom-detail ref="customDetail" work-type="3" :data="detailData.custom_fields_value_json"></custom-detail>
            </c-detail>
        </div>
    </c-dialog>
</template>

<script>
export default {
    name: 'complaintSuggestionDetail',

    props: {
        id: [String, Number]
    },

    data() {
        return {
            detailData: {}
        }
    },

    methods: {
        open() {
            this.request({
                url: '/complaint/suggestion/detail',
                data: {
                    id: this.id
                },
                loading: true,
                success: data => {
                    this.detailData = data;
                    this.$refs.dialog.open();
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>